<template>
	<div class="page_content explore_entity_result explore_entity_inside career programs" aria-label="Career Programs">

		<div class="row page-heading">
			<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
				<div class="module_icon ico-career"></div>
      	<template v-if="career && career.name">
    			<career-title class="title_container" :career="career"></career-title>
    		</template>
      </div>
      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
    		<!--
    		<b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
      		<template slot="button-content">
        		<span class="icon-menu3x3"></span>
      		</template>
    		</b-dropdown>
    		-->
				<div class="btn_container" v-if="showBackToResultButton">
					<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
						<span class="btn_ic ic-back"></span>
						<span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
				</div>
      </div>
    </div>


  		<div class="page_content_container">

  			<career-navigation :active="'programs'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>

  			<div class="row pg_content list_view">
  				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

	          		<template v-if="career.majors && career.majors.length > 0">

	          			<div class="row result_row" v-for="(major, index) in career.majors">

										<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop.prevent="goToProgramGuideDetail(major)" role="button">
											<div class="thumbnail_container ace_sec">
												<div class="thumbnail_img" v-if="major.thumbnailURL">
													<img v-bind:src="major.thumbnailURL" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
												</div>
												<div class="thumbnail" v-else>
													<div class="txt_bx" :id="setTitleBoxWidth(major.title, 'thumb_' + index)" v-html="setTitleInitials(major.title)"></div>
												</div>
											</div>
										</div>

										<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
											<div class="row">
												<div class="col-12 title_row">
													<!--
													<span class="icon icon-career"></span>
													-->
													<a href="javascript://" class="title ace_sec_txt" :id="'entityName_' + index" @click.stop.prevent="goToProgramGuideDetail(major)" :aria-label="major.title">
														{{major.title}}
													</a>
													<!--
													<span
														v-if="isBookmarked(major)"
														@click.stop.prevent="deleteCareerBookmark(major)"
														class="ic_bm_container bookmarked ace_sec_txt"
														title="remove this career from bookmark">
														<span class="icon-bookmark"></span>
													</span>
													<span
														v-else-if="!isBookmarked(major)"
														@click.stop.prevent="bookmarkCareer(major)"
														class="ic_bm_container ace_sec_txt"
														title="bookmark this career">
														<span class="icon-bookmark"></span>
													</span>
													-->

													<b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
														<div class="title_container">
														  {{ major.title }}
														</div>
													</b-popover>
													<div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

												</div>

												<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="major.description">
													 <p class="desc_txt" v-html="major.description"></p>
												</div>
											 	<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
													 No description added for this program
												</div>

												<template v-if="major.description">
                          <div class="col-12 more_lnk_container_v7" :class="showMoreDescLnk(index)">
														<b-btn class="btn_lnk" v-b-modal="'entityDescModal_' + index">
															more
														</b-btn>
                          </div>
                          <b-modal size="xl" :id="'entityDescModal_' + index" :title="major.title" ok-only ok-title="close">

                            <div class="row">

                              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 thumbnail_section">
                                  <div class="thumbnail_container ace_sec">
                                    <div class="thumbnail_img" v-if="major.thumbnailURL">
                                      <img v-bind:src="major.thumbnailURL" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                                    </div>
                                    <div class="thumbnail" v-else>
                                      <div class="txt_bx" v-html="setTitleInitials(major.title)"></div>
                                    </div>
                                  </div>
                              </div>

                              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 description">
                                <div v-html="major.description"></div>
                              </div>

                            </div>

                          </b-modal>
                        </template>

												<div class="col-12" v-if="major.institutionName">
													<div class="row list_info_row inst_name">
														<div class="col-2 info_title">institution</div>
														<div class="col-10 info_val ace_sec_txt" :aria-label="'Institution - ' + major.institutionName">
															{{ major.institutionName }}
														</div>
													</div>
												</div>


											</div>
										</div>


										<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
											<div class="row" v-if="source.disableLMI">

												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">median income</div>
													<div v-if="major.medianIncomePerYear" class="info_val ace_sec_txt" :aria-label="'median income is ' + major.medianIncomePerYear">
														$<span v-html="addCommaInNumber(major.medianIncomePerYear)"></span>
													</div>
													<div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this program">N/A</div>
												</div>

												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">job postings</div>
													<div v-if="major.totalJobPostings" class="info_val ace_sec_txt" :aria-label="'job postings are ' + major.totalJobPostings + ' for this program'">
														<span v-html="addCommaInNumber(major.totalJobPostings)"></span>
													</div>
													<div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this program">N/A</div>
												</div>

												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">growth rate</div>
													<div v-if="major.growthRate" class="info_val ace_sec_txt" :aria-label="'Growth rate is ' + major.growthRate + ' for this program'">
														<span>{{(Math.round(major.growthRate * 100) / 100).toFixed(1)}} %</span>
													</div>
													<div v-else class="info_no_val ace_sec_txt empty_pattern" aria-label="growth rate is not available for this program">N/A</div>
												</div>

											</div>
										</div>


	  						</div>

	        		</template>

	        		<template v-else class="col-12">
								<div class="row">
									<div class="col-12 hd ace_sec_hd" aria-label="Programs">
										<h2>Programs</h2>
										<span class="hd_bdr"></span>
									</div>

									<div class="msg_no_data empty_pattern">
										No program available for this career
									</div>
								</div>
							</template>

						</div>
  			</div> <!-- .pg_content -->

  		</div> <!-- .page_content_container -->

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CareerTitle from './CareerTitle'
import CareerNavigation from './CareerNavigation'

export default {
  name: 'careerPrograms',
  props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
  components: {
  	CareerTitle,
    CareerNavigation
  },
  data: () => {
    return {
      career: {},
      DEFAULT_RETURN_TO: 'exploreCareerResults',
      EXPLORE_RESULTS: 'exploreCareerResults',
			source: [
        'disableLMI'
      ],
    }
  },

  mounted () {
    this.loadDataForCareerPrograms()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadCareer'
    ]),
    async loadDataForCareerPrograms () {
      this.career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
      this.loadLogDashboardActivity({action: 'viewCareerPrograms', page: 'careerPrograms', link: '', careerSocCode: this.code})
    },
    goToProgramGuideDetail (major, cipCodeIndex) {
      let routerParams = {
        code: this.code,
        cipCode: major.cipCode,
        programGuideCode: major.code,
        type: major.type,
        returnTo: 'careerPrograms',
        showBackToResultButton: false
      }
      return this.$router.push({ name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'careerPrograms'} })
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setTitleInitials (streamTitle) {
      let getTitleInitials = streamTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to career results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },
		showMoreDescLnk (entityDescRowId) {
			let descContainerHeight = $('#entityDesc_' + entityDescRowId + ' .desc_txt').height()
			if (descContainerHeight > 65) {
				return 'show_more_link'
			} else {
				return 'hide_more_link'
			}
		},
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerPrograms.vue